<script setup lang="ts">
import { computed, defineAsyncComponent, nextTick, ref } from 'vue';
import { navigate } from 'vike/client/router';
import i18n from '@/localization/i18n';

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

const articles = ref([
    {
        id: 1,
        title: 'Plombier fiable près de chez vous | Comparez les devis',
        description: "Fuite d’eau, robinet cassé, rénovation de salle de bain ? Trouvez un plombier qualifié et comparez gratuitement les devis avec Topela.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-comment-trouver-un-plombier.webp`,
        category: 'Cponseils',
        path: '/blog/particuliers/comment-trouver-un-plombier/',
        publish_date: '03/05/2025'
    },
    {
        id: 2,
        title: 'Entreprise de rénovation | Demandez vos devis gratuits',
        description: "Trouvez une entreprise de rénovation près de chez vous pour refaire une salle de bain, peindre un mur ou rénover un logement.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-recherche-renovation.webp`,
        category: 'Cponseils',
        path: '/blog/particuliers/recherche-renovation/',
        publish_date: '17/05/2025'
    },
    {
        id: 3,
        title: 'Trouvez un jardinier - paysagiste',
        description: "Trouvez un jardinier paysagiste près de chez vous pour entretenir votre jardin, créer un aménagement extérieur ou réaliser des travaux de paysagisme.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-recherche-paysagiste.webp`,
        category: 'Conseils',
        path: '/blog/particuliers/recherche-paysagiste/',
        publish_date: '31/05/2025'
    },
    {
        id: 4,
        title: 'Trouvez un carreleur pour vos travaux de rénovation',
        description: "Trouvez un carreleur qualifié pour vos travaux de rénovation avec Topela. Obtenez des devis gratuits et comparez les professionnels près de chez vous.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-trouvez-carreleur.webp`,
        category: 'Conseils',
        path: '/blog/particuliers/trouvez-un-carreleur/',
        publish_date: '15/10/2025'
    },
    {
        id: 5,
        title: 'Trouvez un peintre pour vos travaux de rénovation',
        description: "Trouvez un peintre qualifié pour vos travaux de rénovation avec Topela. Obtenez des devis gratuits et comparez les professionnels près de chez vous.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-trouvez-peintre.webp`,
        category: 'Conseils',
        path: '/blog/particuliers/trouvez-un-peintre/',
        publish_date: '15/11/2025'
    },
    {
        id: 6,
        title: 'Trouvez un électricien pour vos petits travaux',
        description: "Trouvez un électricien fiable pour vos petits travaux électriques avec Topela. Comparez les devis gratuits et choisissez le professionnel adapté à vos besoins.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-trouvez-electricien.webp`,
        category: 'Conseils',
        path: '/blog/particuliers/trouvez-un-electricien/',
        publish_date: '01/12/2025'
    }
])



const filtered_articles = computed(() => {
    return articles.value
})

const front_article = computed(() => {
    return filtered_articles.value[0]
})

const navigate_to_article = async (path: string) => {
    await navigate(path)
}

const t = i18n.global.t
</script>

<template>
    <Default>>
        <div class="app-content content bg-white pt-5" style="min-height: 73vh; margin-left: 0px">
            <div id="overflow-container" class="content-wrapper container bg-white h-100 pt-0 pt-md-5">
                <main id="main">
                    <h2 class="text-center mt-2 mt-lg-5">{{ t('w_txt_cs_blog_heading') }}</h2>
                    <div class="hero-background d-flex justify-content-center align-items-end rounded-3 mb-2 cursor-pointer"
                        :style="{ backgroundImage: `url('${front_article.image}')` }"
                        @click="navigate_to_article(front_article.path)">
                        <div class="p-2 p-lg-5">
                            <h1 class="text-white text-center px-0 px-lg-5 d-none d-lg-block">
                                {{ front_article.title }}
                            </h1>
                            <h3 class="text-white text-center px-0 px-lg-5 d-block d-lg-none">
                                {{ front_article.title }}
                            </h3>
                            <p class="text-white text-center px-0 px-lg-5 d-none d-lg-block sized-text">
                                {{ front_article.description }} 
                            </p>
                        </div>
                    </div>
                    <p class="text-center px-0 px-lg-5 d-block d-lg-none sized-text">
                        {{ front_article.description }}
                    </p>

                    <section v-if="filtered_articles.length > 1">
                        <h4 class="mb-4">{{ t('w_txt_blog_recent_articles') }}</h4>
                        <div class="row">
                            <div v-if="filtered_articles.length > 1"
                                v-for="article in filtered_articles.slice().reverse()"
                                :class="{ 'd-none': article.id === front_article.id }" class="col-lg-4 mb-5">
                                <!-- Using .slice().reverse() to display articles in reverse order  -->
                                <div class="">
                                    <img class="rounded-3 w-100 mb-4 cursor-pointer" :src="article.image"
                                        alt="Card image cap" style="aspect-ratio: 16 / 9; height: 220px !important; object-fit: cover;"
                                        @click="navigate_to_article(article.path)" />
                                    <div>
                                        <h4 class="cursor-pointer" @click="navigate_to_article(article.path)">{{
                                            article.title }}</h4>
                                        <p class="sized-text">
                                            {{ article.description }}
                                        </p>
                                        <small class="mt-2">
                                            <strong>{{ t('g_txt_published_on') }} {{ article.publish_date }}</strong>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div v-else class="pb-5">
                        <div class="pt-5"></div>
                    </div>
                </main>
            </div>
        </div>
    </Default>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.sized-text {
    font-size: 16px !important;
}

.primary-btn {
    background-color: #49AFDA;
    color: white;
    border-radius: 10px;
}

.hero-background {
    /* height: 60vh; */
    background-position: 25% center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    margin-top: 5vh;
    position: relative;
    aspect-ratio: 19/9;
}

.hero-background::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    /* Adjust opacity as needed */
    z-index: 1;
    border-radius: 0.5rem;
}

.hero-background * {
    position: relative;
    z-index: 2;
    /* Ensures your text appears above the overlay */
}
</style>